module.exports = __webpack_public_path__ + "static/media/BreathingTechniques.cb9bc344.png";